import { CUSTOMER_SERVICE_PHONE_NUMBER } from '@seek/shared-constants';
import { Strong } from 'braid-design-system';

import type { EmployerSiteName } from 'src/types';

export interface Props {
  site: EmployerSiteName;
}

const CsPhoneNumber = ({ site }: Props) => (
  <Strong>{CUSTOMER_SERVICE_PHONE_NUMBER[site]}</Strong>
);

export default CsPhoneNumber;
